import React, { useState } from "react";
import { Link } from "react-router-dom";
import PageTopSlider from "../components/PageTopSlider";
import GalleryViewer from "../components/GalleryViewer";
import ReviewsSlider from "../components/ReviewsSlider";
import ContactForm from "../components/ContactForm";
import SEO from "../components/SEO";

export default function Trykprovning() {
  const [openFaq, setOpenFaq] = useState(null);

  const faqs = [
    {
      q: "Hvad er en blowerdoor test?",
      a: "En blowerdoor test, også kaldet trykprøvning, er en metode til at måle, hvor tæt en bygning er. Ved hjælp af en speciel ventilator – en såkaldt blowerdoor – skabes et trykfald mellem bygningens indre og ydre. Det gør det muligt at registrere, hvor der slipper luft ud eller ind, og dermed identificere utætheder, som kan føre til energitab, træk og fugtproblemer.",
    },
    {
      q: "Hvad koster en blowerdoor test hos ET Danmark?",
      a: "Prisen for en blowerdoor test starter fra 3.300 kr. inkl. moms. Den endelige pris afhænger af bygningens størrelse og kompleksitet samt omfanget af den ønskede dokumentation. Testen udføres af certificerede teknikere med professionelt måleudstyr, og resultatet leveres som en rapport over bygningens lufttæthed.",
    },
    {
      q: "Hvordan foregår en trykprøvning?",
      a: "Bygningen klargøres efter den relevante prøvningsmetode. Herefter måles bygningens lufttæthed med BlowerDoor-udstyr ved kontrolleret over- og undertryk.",
    },
    {
      q: "Hvad viser resultatet af en blowerdoor test?",
      a: "Resultatet viser bygningens lufttæthed, typisk angivet som hvor meget luft, der siver ind eller ud pr. time ved et givent tryk. Et lavt tal betyder en tæt bygning med mindre varmetab og bedre energieffektivitet. Rapporten gør det muligt at lokalisere præcist, hvor der er behov for tætning eller forbedringer.",
    },
    {
      q: "Hvornår skal man lave en trykprøvning?",
      a: "En trykprøvning er særlig relevant ved nybyggeri, hvor man vil sikre, at bygningen lever op til energikravene i bygningsreglementet. Den kan også udføres i forbindelse med renovering eller energieftersyn af eksisterende bygninger for at finde utætheder, reducere energiforbruget og forbedre indeklimaet.",
    },
    {
      q: "Hvilke fordele er der ved trykprøvning af hus?",
      a: "Trykprøvning giver flere fordele:\n• Lavere energiforbrug gennem tættere konstruktioner.\n• Bedre komfort uden træk og kolde zoner.\n• Sundere indeklima med reduceret risiko for fugt og skimmelsvamp.\n• Øget ejendomsværdi, fordi dokumenteret energieffektivitet er attraktivt for købere.",
    },
    {
      q: "Hvem må udføre en blowerdoor test?",
      a: "Kun certificerede teknikere med professionelt måleudstyr bør udføre en blowerdoor test. Det kræver erfaring og præcision at opstille udstyret korrekt og tolke resultaterne, så de kan bruges som dokumentation over for myndigheder eller som grundlag for energiforbedringer.",
    },
    {
      q: "Hvor lang tid tager en trykprøvning?",
      a: "Varigheden afhænger af bygningens størrelse og kompleksitet. For et almindeligt enfamiliehus tager testen som regel få timer at udføre. Større bygninger eller ejendomme med mange rum kan tage længere tid, da forberedelse og målinger skal udføres mere detaljeret.",
    },
    {
      q: "Er trykprøvning et lovkrav ved nybyggeri?",
      a: "Ja. Ved nybyggeri stiller bygningsreglementet krav om, at bygningens lufttæthed skal dokumenteres. Trykprøvningen bruges som officiel dokumentation for, at energikravene er opfyldt. Den kan også være påkrævet i forbindelse med certificering eller aflevering af byggeriet.",
    },
    {
      q: "Hvad skal man forberede inden en trykprøvning?",
      a: "Inden testen bør alle døre og vinduer være monteret, og åbninger som aftræk og rørgennemføringer bør være færdiggjorte. Bygningen skal være ryddet, så teknikeren har fri adgang til relevante områder. Det er også vigtigt at følge eventuelle anvisninger fra den udførende konsulent for at sikre en præcis måling.",
    },
  ];

  const primaryCities = [
    { name: "Horsens", slug: "horsens" },
    { name: "Vejle", slug: "vejle" },
    { name: "Aarhus", slug: "aarhus" },
    { name: "Skanderborg", slug: "skanderborg" },
    { name: "Juelsminde", slug: "juelsminde" },
    { name: "Aalborg", slug: "aalborg" },
    { name: "Herning", slug: "herning" },
    { name: "Randers", slug: "randers" },
    { name: "Fredericia", slug: "fredericia" },
    { name: "Kolding", slug: "kolding" },
    { name: "Odense", slug: "odense" },
    { name: "Svendborg", slug: "svendborg" },
  ];

  return (
    <div className="bg-[#FAF9F6] text-stone-800">
      <SEO
        title="Trykprøvning i hele Jylland og Fyn | Kontakt os for en uforpligtende snak"
        description="Trykprøvning kan hjælpe dig med at identificere og rette problemer relateret til bygningens tæthed. Opnå bedre energieffektivitet og komfort."
        canonical="https://www.etdanmark.com/trykproevning"
        ogImage="https://assets.auxodev.dk/assets/769d49b2-5afc-461a-944c-d9cca711718f/dsc07384_05a504c6.jpg"
        faqs={faqs}
      />
      {/* 1. TOP SLIDER HERO */}
      <PageTopSlider
        title="Trykprøvning"
        subtitle="Står du overfor en renovering eller nybyggeri og ønsker at sikre dig, at ejendommen er energieffektiv og fri for utætheder? Professionel BlowerDoor tæthedsprøvning med hurtig rapportlevering."
        badge="Professionel BlowerDoor måling"
        breadcrumbs={[
          { label: "Forside", to: "/" },
          { label: "Ydelser", to: "/#ydelser" },
          { label: "Trykprøvning" },
        ]}
        priceBadge="Fra 3.300 kr. inkl. moms"
        actions={
          <>
            <Link
              to="/prisberegner"
              className="px-6 py-3 rounded-full bg-emerald-600 hover:bg-emerald-500 text-white font-bold text-sm shadow-md transition-all flex items-center gap-2"
            >
              <i className="fa-solid fa-calculator text-xs" aria-hidden="true"></i>
              <span>Beregn pris online</span>
            </Link>
            <a
              href="tel:+4542499595"
              className="px-6 py-3 rounded-full bg-white/15 hover:bg-white/25 border border-white/30 text-white font-bold text-sm backdrop-blur-xs transition-all flex items-center gap-2"
            >
              <i className="fa-solid fa-phone text-emerald-300 text-xs" aria-hidden="true"></i>
              <span>Ring 42 49 95 95</span>
            </a>
          </>
        }
        image={{
          url: "https://assets.auxodev.dk/assets/769d49b2-5afc-461a-944c-d9cca711718f/dsc07344-2_4f32161c.jpg",
          alt: "BlowerDoor trykprøvning monteret i døråbning",
        }}
      />

      {/* RÅDGIVNING & INTRODUKTION */}
      <section className="py-14 bg-white border-b border-stone-200/70">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
            <div className="lg:col-span-7 space-y-5">
              <h2 className="text-2xl sm:text-3xl font-bold text-stone-900 tracking-tight">
                Hvorfor er trykprøvning vigtigt?
              </h2>

              <div className="space-y-3 text-stone-600 text-sm sm:text-base leading-relaxed">
                <p>
                  Trykprøvning er en essentiel service, der kan hjælpe dig med at identificere og rette problemer relateret til bygningens tæthed, hvilket sikrer bedre energieffektivitet og komfort i dit hjem, virksomhed eller institution.
                </p>
                <p>
                  En trykprøvning (BlowerDoor test) dokumenterer, om bygningens klimaskærm overholder bygningsreglementets krav til lufttæthed, og afslører skjulte utætheder før de medfører fugt- eller varmeskader.
                </p>
              </div>

              <div className="p-4 rounded-2xl bg-[#11463A] text-white flex flex-col sm:flex-row sm:items-center justify-between gap-4 shadow-sm">
                <div>
                  <span className="text-xs uppercase text-emerald-300 font-semibold block">Pris for BlowerDoor:</span>
                  <span className="text-2xl font-bold text-white">Fra 3.300 kr. inkl. moms</span>
                </div>
                <div className="flex gap-2">
                  <a
                    href="#kontakt"
                    className="px-5 py-2.5 rounded-full bg-white text-stone-900 font-bold text-xs hover:bg-stone-100 transition-colors"
                  >
                    Kontakt os
                  </a>
                  <Link
                    to="/prisberegner"
                    className="px-5 py-2.5 rounded-full bg-emerald-600 text-white font-bold text-xs hover:bg-emerald-500 transition-colors"
                  >
                    Beregn pris
                  </Link>
                </div>
              </div>
            </div>

            <div className="lg:col-span-5">
              <div className="rounded-3xl overflow-hidden shadow-xl border-4 border-stone-100 bg-stone-100 aspect-16/11">
                <img
                  src="https://assets.auxodev.dk/cdn-cgi/image/width=900,quality=85,format=auto/assets/769d49b2-5afc-461a-944c-d9cca711718f/dsc07324.jpg"
                  alt="Trykprøvning digitalt præcisionsmåleudstyr"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 2. HVAD ER TRYKPRØVNING (BLOWERDOOR) */}
      <section className="py-16 bg-white border-b border-stone-200/70">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
            <div className="lg:col-span-6 space-y-4">
              <h2 className="text-2xl sm:text-3xl font-bold text-stone-900 tracking-tight">
                Hvad er trykprøvning, også kendt som blowerdoor?
              </h2>
              <div className="space-y-3 text-stone-600 text-sm sm:text-base leading-relaxed">
                <p>
                  Trykprøvning er en metode til at måle, hvor tæt en bygning er. Ved at skabe et trykfald mellem bygningens indre og det ydre miljø, kan man opdage utætheder og andre fejl, der kan føre til energitab.
                </p>
                <p>
                  Processen indebærer brug af avanceret udstyr som en blowerdoor, der opstiller en standardiseret luftstrøm for at presse luft ud eller ind i bygningen. Dette hjælper med at identificere, hvor luft lækker ud fra bygningen.
                </p>
              </div>
            </div>

            <div className="lg:col-span-6 bg-[#FAF9F6] border border-stone-200 p-7 rounded-3xl space-y-3">
              <h3 className="font-bold text-stone-900 text-base flex items-center gap-2">
                <i className="fa-solid fa-gauge text-[#165B4C]" aria-hidden="true"></i>
                Hvorfor er tæthed afgørende?
              </h3>
              <p className="text-xs sm:text-sm text-stone-600 leading-relaxed">
                Bygningsreglementet (BR18) stiller strenge krav til nye bygningers lufttæthed ved 50 Pa trykforskel. En utæt konstruktion kan føre til fugt i konstruktionen, træk og afvist ibrugtagningstilladelse fra kommunen.
              </p>
              <div className="pt-2 border-t border-stone-200 text-xs text-stone-700 font-medium space-y-1">
                <p>✓ Udføres i henhold til gældende standarder</p>
                <p>✓ Komplet testrapport med dokumenterede kurver og resultater</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 3. FORDELE VED TRYKPRØVNING */}
      <section className="py-16 sm:py-20 bg-stone-50 border-b border-stone-200/70">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="max-w-3xl mb-12">
            <h2 className="text-3xl sm:text-4xl font-extrabold text-stone-900 tracking-tight">
              Fordele ved trykprøvning af hus og andet byggeri
            </h2>
            <p className="text-stone-600 text-sm sm:text-base mt-2">
              En grundig trykprøvning af huset tilbyder flere fordele:
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="bg-white p-6 rounded-2xl border border-stone-200 shadow-2xs">
              <div className="w-10 h-10 rounded-xl bg-emerald-100 text-emerald-800 flex items-center justify-center mb-4">
                <i className="fa-solid fa-piggy-bank" aria-hidden="true"></i>
              </div>
              <h3 className="font-bold text-stone-900 text-base">Energibesparelser</h3>
              <p className="text-xs text-stone-600 mt-2 leading-relaxed">
                Ved at identificere og forsegle utætheder, kan du reducere energiforbruget og dermed spare på dine energiregninger.
              </p>
            </div>

            <div className="bg-white p-6 rounded-2xl border border-stone-200 shadow-2xs">
              <div className="w-10 h-10 rounded-xl bg-emerald-100 text-emerald-800 flex items-center justify-center mb-4">
                <i className="fa-solid fa-smile" aria-hidden="true"></i>
              </div>
              <h3 className="font-bold text-stone-900 text-base">Forbedret komfort</h3>
              <p className="text-xs text-stone-600 mt-2 leading-relaxed">
                Eliminer træk og kulde spots, der er resultatet af utætheder, hvilket skaber en mere behagelig bolig, eller arbejdsplads.
              </p>
            </div>

            <div className="bg-white p-6 rounded-2xl border border-stone-200 shadow-2xs">
              <div className="w-10 h-10 rounded-xl bg-emerald-100 text-emerald-800 flex items-center justify-center mb-4">
                <i className="fa-solid fa-heart-pulse" aria-hidden="true"></i>
              </div>
              <h3 className="font-bold text-stone-900 text-base">Sundere indeklima</h3>
              <p className="text-xs text-stone-600 mt-2 leading-relaxed">
                Reducerer risikoen for skimmelsvamp og fugt, ved at kontrollere luftstrømme ind og ud af byggeriet.
              </p>
            </div>

            <div className="bg-white p-6 rounded-2xl border border-stone-200 shadow-2xs">
              <div className="w-10 h-10 rounded-xl bg-emerald-100 text-emerald-800 flex items-center justify-center mb-4">
                <i className="fa-solid fa-house-chimney-crack" aria-hidden="true"></i>
              </div>
              <h3 className="font-bold text-stone-900 text-base">Øger værdien af dit hjem</h3>
              <p className="text-xs text-stone-600 mt-2 leading-relaxed">
                Et energieffektivt hjem med dokumenteret lavt energiforbrug, kan være mere attraktivt for købere, hvis du overvejer at sælge.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* 4. HVORDAN UDFØRES TRYKPRØVNINGEN? (PROCES I TRIN) */}
      <section className="py-16 bg-white border-b border-stone-200/70">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="max-w-3xl mb-12">
            <h2 className="text-3xl font-extrabold text-stone-900 tracking-tight">
              Hvordan udføres trykprøvningen?
            </h2>
            <p className="text-stone-600 text-sm sm:text-base mt-2 leading-relaxed">
              Trykprøvning udføres typisk af certificerede teknikere, der anvender specialiseret udstyr til at måle lufttætheden. Processen omfatter følgende trin:
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="p-7 rounded-2xl bg-[#FAF9F6] border border-stone-200">
              <div className="w-9 h-9 rounded-xl bg-[#165B4C] text-white font-bold flex items-center justify-center text-sm mb-4">
                1
              </div>
              <h3 className="text-lg font-bold text-stone-900 mb-2">Forberedelse af bygningen</h3>
              <p className="text-xs sm:text-sm text-stone-600 leading-relaxed">
                Bygningen klargøres efter gældende prøvningsmetode, hvorefter BlowerDoor-udstyret etablerer kontrolleret over- og undertryk, så bygningens lufttæthed kan dokumenteres.
              </p>
            </div>

            <div className="p-7 rounded-2xl bg-[#FAF9F6] border border-stone-200">
              <div className="w-9 h-9 rounded-xl bg-[#165B4C] text-white font-bold flex items-center justify-center text-sm mb-4">
                2
              </div>
              <h3 className="text-lg font-bold text-stone-900 mb-2">Opstilling af udstyret</h3>
              <p className="text-xs sm:text-sm text-stone-600 leading-relaxed">
                En blower door enhed installeres i en udvendig døråbning. Udstyret inkluderer en kraftig ventilator, der kontrolleres til at skabe et specifikt tryk i bygningen.
              </p>
            </div>

            <div className="p-7 rounded-2xl bg-[#FAF9F6] border border-stone-200">
              <div className="w-9 h-9 rounded-xl bg-[#165B4C] text-white font-bold flex items-center justify-center text-sm mb-4">
                3
              </div>
              <h3 className="text-lg font-bold text-stone-900 mb-2">Udførelse af testen & lækagesøgning</h3>
              <p className="text-xs sm:text-sm text-stone-600 leading-relaxed">
                Ved at justere trykket kan teknikeren identificere, hvor og hvor meget luft der lækker ind eller ud.
              </p>
            </div>
          </div>

          {/* KOMBINATION: TRYKPRØVE + FUGTMÅLING */}
          <div className="mt-10 p-8 rounded-3xl bg-emerald-50/80 border border-emerald-200/90 flex flex-col md:flex-row items-center justify-between gap-6">
            <div className="space-y-2 max-w-2xl">
              <div className="inline-flex items-center gap-2 px-3 py-0.5 rounded-full bg-emerald-100 text-emerald-800 text-xs font-bold uppercase tracking-wider">
                <i className="fa-solid fa-droplet" aria-hidden="true"></i>
                <span>Tæthed & Fugt</span>
              </div>
              <h3 className="text-xl sm:text-2xl font-bold text-stone-900 tracking-tight">
                Trykprøve + fugtmåling: find utætheden – og tjek for fugt
              </h3>
              <p className="text-stone-700 text-xs sm:text-sm leading-relaxed">
                Under trykprøven finder vi utæthederne i klimaskærmen. Hvor varm, fugtig indeluft kan trænge ud i konstruktionen, kan der opstå fugt. En fugtmåling ved de utætte steder viser, om træ og isolering allerede er blevet fugtigt. Bestiller du begge dele, kan vi lave dem ved samme besøg.
              </p>
            </div>
            <div className="flex flex-col sm:flex-row gap-3 shrink-0 w-full md:w-auto">
              <Link
                to="/fugtmaaling"
                className="px-5 py-2.5 rounded-full bg-white hover:bg-stone-50 border border-emerald-300 text-emerald-900 font-bold text-xs shadow-2xs transition-colors text-center"
              >
                Se fugtmåling &rarr;
              </Link>
              <a
                href="#kontakt"
                className="px-5 py-2.5 rounded-full bg-[#165B4C] hover:bg-[#11463A] text-white font-bold text-xs shadow-2xs transition-colors text-center"
              >
                Få tilbud på begge
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* 5. VÆLG DEN RETTE KONSULENT & JYLLAND DÆKNING */}
      <section className="py-16 bg-stone-50 border-b border-stone-200/70">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
            <div className="lg:col-span-6 space-y-4">
              <h2 className="text-2xl sm:text-3xl font-bold text-stone-900 tracking-tight">
                Vælg den rette konsulent til at udføre blowerdoor
              </h2>
              <div className="space-y-3 text-stone-600 text-sm leading-relaxed">
                <p>
                  Når du vælger en konsulent til at udføre trykprøvning, er det vigtigt at vælge en med erfaring og de rette kvalifikationer.
                </p>
                <p>
                  Hos ET Danmark ApS tilbyder vi professionel trykprøvning, med certificering i henhold til de nyeste standarder.
                </p>
                <p>
                  Vi benytter kun det nyeste og mest præcise udstyr for at sikre, at du får de mest pålidelige resultater.
                </p>
              </div>
            </div>

            <div className="lg:col-span-6 space-y-4">
              <h2 className="text-2xl sm:text-3xl font-bold text-stone-900 tracking-tight">
                Trykprøvning i hele Jylland og Fyn
              </h2>
              <p className="text-stone-600 text-sm leading-relaxed">
                Vi tilbyder trykprøvning af huse, virksomheder og institutioner i hele Jylland og Fyn. Som certificerede energikonsulenter er vi klar til at hjælpe dig med at identificere utætheder og optimere lufttætheden i din ejendom.
              </p>
              <p className="text-xs font-semibold text-stone-800">
                Her er nogle af de primære byer, hvor vi opererer:
              </p>
              <div className="flex flex-wrap gap-2">
                {primaryCities.map((city) => (
                  <Link
                    key={city.slug}
                    to={`/trykproevning-i-${city.slug}`}
                    className="px-3 py-1.5 rounded-lg bg-white hover:bg-emerald-50 border border-stone-200 hover:border-emerald-500/50 text-xs font-semibold text-stone-800 hover:text-emerald-800 transition-all shadow-2xs inline-flex items-center gap-1"
                  >
                    <span>{city.name}</span>
                    <i className="fa-solid fa-arrow-right text-[9px] text-emerald-600 opacity-60" aria-hidden="true"></i>
                  </Link>
                ))}
              </div>
              <p className="text-xs text-stone-500 leading-relaxed pt-1">
                Udover disse byer dækker vi også andre områder som{" "}
                <Link to="/trykproevning-i-esbjerg" className="text-emerald-700 font-semibold hover:underline">
                  Esbjerg
                </Link>
                ,{" "}
                <Link to="/trykproevning-i-silkeborg" className="text-emerald-700 font-semibold hover:underline">
                  Silkeborg
                </Link>
                ,{" "}
                <Link to="/trykproevning-i-viborg" className="text-emerald-700 font-semibold hover:underline">
                  Viborg
                </Link>
                , og mange flere. Vi stræber efter at tilbyde vores professionelle trykprøvning af huse og bygninger i hele Jylland og Fyn for at sikre, at alle kan drage fordel af energieffektive løsninger og forbedret ejendomsværdi.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* KOMBINATION AF TRYKPRØVNING OG TERMOGRAFI */}
      <section className="py-10 bg-white border-b border-stone-200/70">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="text-left max-w-3xl mb-8">
            <h2 className="text-2xl sm:text-3xl font-extrabold text-stone-900 tracking-tight">
              Trykprøvning og termografi – den optimale kombination
            </h2>
            <p className="mt-2 text-stone-600 text-sm sm:text-base leading-relaxed">
              Når BlowerDoor-udstyret skaber et undertryk i bygningen, suges kold udeluft ind gennem revner og sprækker. Med et infrarødt termografikamera gøres selv mikroskopiske utætheder og temperaturforskelle lynhurtigt synlige.
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 sm:gap-4">
            {[
              {
                icon: "fa-wind",
                title: "Utætheder og træk",
                desc: "Præcis lokalisering af utætheder ved vinduer, lofter og fodpaneler.",
              },
              {
                icon: "fa-layer-group",
                title: "Isoleringsfejl",
                desc: "Afslører manglende, forkert monteret eller sammenfaldet isolering.",
              },
              {
                icon: "fa-temperature-arrow-down",
                title: "Kuldebroer",
                desc: "Fanger samlinger der leder varme væk og giver risiko for kondens/skimmel.",
              },
              {
                icon: "fa-magnifying-glass",
                title: "Fejlsøgning i nybyggeri",
                desc: "Kvalitetssikring forud for aflevering eller 1- og 5-års eftersyn.",
              },
              {
                icon: "fa-fire-flame-curved",
                title: "Højt varmeforbrug",
                desc: "Få syn for sagen hvis varmeregningen er uforklarligt høj.",
              },
              {
                icon: "fa-file-circle-check",
                title: "Dokumentation",
                desc: "Fotodokumentation og termogrammer klar til udbedring eller forsikring.",
              },
            ].map((item, idx) => (
              <div
                key={idx}
                className="bg-stone-50 border border-stone-200/80 rounded-xl p-4 text-left hover:border-[#165B4C]/40 transition-colors flex flex-col items-start"
              >
                <div className="w-10 h-10 rounded-lg bg-white border border-stone-200 flex items-center justify-center text-[#165B4C] mb-2.5 shadow-xs">
                  <i className={`fa-solid ${item.icon} text-sm`} aria-hidden="true" />
                </div>
                <h3 className="font-bold text-stone-900 text-xs sm:text-sm leading-snug mb-1">
                  {item.title}
                </h3>
                <p className="text-stone-600 text-xs leading-relaxed">
                  {item.desc}
                </p>
              </div>
            ))}
          </div>

          <div className="mt-6 flex justify-end">
            <Link
              to="/termografi"
              className="inline-flex items-center text-sm font-semibold text-[#165B4C] hover:text-[#0f3f35] transition-colors gap-1.5"
            >
              Læs mere om termografisk undersøgelse
              <i className="fa-solid fa-arrow-right text-xs" aria-hidden="true" />
            </Link>
          </div>
        </div>
      </section>

      {/* 6. CMS GALLERI FOR TRYKPRØVNING */}
      <section className="py-16 bg-stone-50 border-b border-stone-200/70">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <GalleryViewer
            gallerySlug="trykprovning"
            title="Galleri: BlowerDoor trykprøvning"
            subtitle="Opstilling af ventilator, dørramme og måling på nybyg og renovering"
          />
        </div>
      </section>

      {/* 7. OFTE STILLEDE SPØRGSMÅL (FAQ) */}
      <section className="py-16 sm:py-20 bg-stone-50 border-b border-stone-200/70">
        <div className="max-w-4xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-10">
            <h2 className="text-3xl sm:text-4xl font-extrabold text-stone-900 tracking-tight">
              Ofte stillede spørgsmål om blowerdoor test og trykprøvning
            </h2>
            <p className="text-stone-600 text-sm mt-2">
              Få svar på spørgsmål om forberedelse, priser, krav i bygningsreglementet og udførelse.
            </p>
          </div>

          <div className="space-y-3">
            {faqs.map((item, idx) => (
              <div
                key={idx}
                className="bg-white rounded-2xl border border-stone-200 overflow-hidden shadow-2xs"
              >
                <button
                  type="button"
                  onClick={() => setOpenFaq(openFaq === idx ? null : idx)}
                  className="w-full px-6 py-4 text-left font-bold text-stone-900 flex items-center justify-between gap-4 hover:bg-stone-50/60 transition-colors"
                >
                  <span className="text-sm sm:text-base">{item.q}</span>
                  <i
                    className={`fa-solid fa-chevron-down text-xs text-stone-400 transition-transform duration-200 shrink-0 ${
                      openFaq === idx ? "rotate-180 text-[#165B4C]" : ""
                    }`}
                    aria-hidden="true"
                  ></i>
                </button>
                {openFaq === idx && (
                  <div className="px-6 pb-5 pt-1 text-xs sm:text-sm text-stone-600 leading-relaxed border-t border-stone-100 whitespace-pre-line">
                    {item.a}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 8. SOCIAL PROOF */}
      <ReviewsSlider />

      {/* 9. KONTAKT FORMULAR */}
      <section id="kontakt" className="py-16 sm:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-start">
            <div className="lg:col-span-5 space-y-5">
              <h2 className="text-2xl sm:text-3xl font-extrabold text-stone-900 tracking-tight">
                Kontakt os for professionel rådgivning omkring trykprøvning/Blowerdoor
              </h2>
              <div className="space-y-3 text-stone-600 text-sm leading-relaxed">
                <p>
                  Er du klar til at optimere dit hjem med professionel trykprøvning? Kontakt os i dag for at drøfte dine behov, og hvordan vi kan hjælpe dig med at opnå bedre energieffektivitet og komfort i dit hjem.
                </p>
                <p>
                  Ring til os på <a href="tel:+4542499595" className="font-bold text-stone-900 whitespace-nowrap">42 49 95 95</a> , eller send en e-mail til <a href="mailto:info@etdanmark.com" className="font-bold text-stone-900 whitespace-nowrap">info@etdanmark.com</a> .
                </p>
              </div>

              <div className="p-5 rounded-2xl bg-stone-50 border border-stone-200 space-y-2 text-xs text-stone-700">
                <p className="font-semibold text-stone-900">ET Danmark ApS</p>
                <p>Bjerrevej 62 A, 8700 Horsens</p>
                <p>Telefon: 42 49 95 95 &bull; CVR: 41026138</p>
              </div>
            </div>

            <div className="lg:col-span-7">
              <ContactForm
                defaultService="Trykprøvning"
                title="Bestil trykprøvning eller få et uforpligtende tilbud"
                subtitle="Du kan let og hurtigt sende os en besked i nedenstående formular."
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
